// app/javascript/controllers/popup_controller.js
import { Controller } from "stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  static targets = ["radioButton", "modal"];

  connect() {
    this.radioButtonTargets.forEach((radioButton) => {
      radioButton.addEventListener("change", (event) => {
        if (event.target.checked) {
          this.showPopup(event.target);
        }
      });
    });
  }

  showPopup(target) {
    const modalElement = this.modalTarget;
    const modal = new Modal(modalElement);
    const modalBody = modalElement.querySelector('.modal-body');

    modalBody.innerHTML = `To apply for Veteran Credits please upload in the attachment tab a completed <strong><a href="https://chqgov.com/sites/default/files/inline-files/FORM%20-%20Veterans%20Credit%209-2022.pdf" target="blank">Veteran’s Credit Application form</a></strong>, along with a copy of your DD214.`;
    modal.show();
  }
}
